var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M11.6 11.9h76.1V88H11.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#b)",
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "round"
    },
    d: "M38.2 15.7c-12.6 0-22.8 10.2-22.8 22.8v22.8c0 12.6 10.2 22.8 22.8 22.8H61c12.6 0 22.8-10.2 22.8-22.8V38.5c0-12.6-10.2-22.8-22.8-22.8H38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#b)",
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "round"
    },
    d: "M38.1 31c-4.4 0-8 3.6-8 8v.7c0 4.4 3.6 8 8 8h.4c4.4 0 8-3.6 8-8V39c0-4.4-3.6-8-8-8h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 61.9h34.7m-6.7-22.5h6.7",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreEvent);
export default __webpack_public_path__ + "static/media/exploreEvent.6f739466c81b16dcd4dc70fe767a1538.svg";
export { ForwardRef as ReactComponent };